import { useEffect } from 'react';

import {
  CashGamesGroupedUpdateDocument,
  useCashGamesGroupedQuery
} from '@swf/generated/graphql/poker/CG/hooks';

import useConfigVars from './useConfigVars';

const useSimpleGamesSubscription = () => {
  const variables = useConfigVars();

  const { data, loading, error, subscribeToMore } = useCashGamesGroupedQuery({
    variables,
    ssr: true
  });

  useEffect(() => {
    const unsubscribe = subscribeToMore({
      document: CashGamesGroupedUpdateDocument,
      variables,
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;
        const newGames = subscriptionData.data.cashGamesGrouped;

        return {
          ...prev,
          cashGamesGrouped: newGames
        };
      }
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [subscribeToMore, variables]);

  return { data, loading, error };
};

export default useSimpleGamesSubscription;
